"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyResolver = void 0;
const inversify_1 = require("inversify");
class DependencyResolver {
    constructor(logger, container) {
        this.depCtors = new Map();
        this.orderedDeps = [];
        this.logger = logger;
        this.container = container !== null && container !== void 0 ? container : new inversify_1.Container();
    }
    getConfigFor(ctor) {
        if (!this.depCtors.has(ctor))
            throw new Error(`Can't get configuration for plugin ${ctor.name}: plugin is not registered.`);
        return this.depCtors.get(ctor);
    }
    setConfigFor(ctor, config) {
        if (!this.depCtors.has(ctor))
            throw new Error(`Can't set configuration for plugin ${ctor.name}: plugin is not registered.`);
        this.depCtors.set(ctor, config);
    }
    isRegistered(ctor) {
        return this.depCtors.has(ctor);
    }
    register(ctor, config) {
        this.logger.debug("Register new dependency", { name: ctor.name });
        if (this.depCtors.has(ctor))
            throw new Error(`Dependency ${ctor.name} is already registered.`);
        this.depCtors.set(ctor, config);
        this.container
            .bind(ctor)
            .toSelf()
            .inSingletonScope()
            .onActivation((ctx, instance) => {
            this.logger.info("Dependency activated", { name: instance.constructor.name });
            this.orderedDeps.push({
                instance,
                config: this.depCtors.get(ctor),
            });
            return instance;
        });
    }
    unregister(ctor) {
        this.logger.debug("Unregister dependency", { name: ctor.name });
        if (!this.depCtors.has(ctor)) {
            this.logger.warn("Trying to unregister a dependency, but the dependency was not found. Ignoring.", { name: ctor.name });
            return;
        }
        this.depCtors.delete(ctor);
        this.container.unbind(ctor);
    }
    resolve() {
        this.logger.info("Resolving dependencies");
        for (const [ctor] of this.depCtors) {
            // Resolve dependency
            this.container.get(ctor);
        }
        this.logger.info("Dependencies resolved and ordered", { set: this.orderedDeps });
    }
    build() {
        this.resolve();
        return this.orderedDeps;
    }
}
exports.DependencyResolver = DependencyResolver;
//# sourceMappingURL=resolver.js.map